import {SIDO_AREA_INFO} from '@/map/constants';

export const getSidoItem = (name: string) => {
  const compareName = (name: string) =>
    SIDO_AREA_INFO.find((i) => i.name === name);
  const compareAlias = (name: string) =>
    SIDO_AREA_INFO.find((i) => name.indexOf(i.alias) >= 0);

  const getItem = (name: string) => compareName(name) || compareAlias(name);

  return getItem(name);
};

export const sortSido = (list: Array<{name: string; [key: string]: any}>) => {
  if (!list?.length) {
    return list;
  }

  const getOrder = (name: string) =>
    getSidoItem(name)?.order || SIDO_AREA_INFO.length + 100;

  return [...list].sort((a, b) => getOrder(a.name) - getOrder(b.name));
};

export const getSidoShortName = (name: string) => {
  if (!name) {
    return '';
  } else if (name.indexOf('전북특별자치도') >= 0) {
    return name.replace('전북특별자치도', '전라북도');
  } else {
    return name.replace(/특별자치|특별|광역/, '');
  }
};

export const getSidoName = (sido?: string) => {
  if (sido) {
    const alias = getSidoItem(sido)?.alias;

    return alias ?? getSidoShortName(sido).replace(/시$/, '');
  } else {
    return '시/도';
  }
};
